import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, TextField, Button, useTheme, CircularProgress } from '@mui/material';
import { useMaintenance } from '../../contexts/MaintenanceContext';

const MaintenanceWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const theme = useTheme();
  const { maintenanceBO, verifyPin, messageBO } = useMaintenance();
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const verified = sessionStorage.getItem('maintenanceVerified') === 'true';
    if (verified) setIsVerified(true);
    setIsLoading(false);
  }, []);

  const handlePinSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (verifyPin('bo', pin)) {
      sessionStorage.setItem('maintenanceVerified', 'true');
      setIsVerified(true);
      setError('');
    } else {
      setError('Código incorrecto');
    }
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (maintenanceBO && !isVerified) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: theme.palette.background.default,
          p: 3,
        }}
      >
        <Paper elevation={3} sx={{ p: 4, maxWidth: 500, width: '100%', textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 3, color: theme.palette.warning.main }}>
            {messageBO.title || 'Sitio en Mantenimiento'}
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mb: 4 }}>
            {messageBO.description || 'Estamos realizando tareas de mantenimiento. Por favor, intente nuevamente más tarde.'}
          </Typography>

          <Box component="form" onSubmit={handlePinSubmit} sx={{ mt: 4 }}>
            <TextField
              fullWidth
              type="password"
              label="Código de acceso"
              variant="outlined"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              error={!!error}
              helperText={error}
              inputProps={{ maxLength: 4, inputMode: 'numeric' }}
              sx={{ mb: 2 }}
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
              size="large"
            >
              Ingresar
            </Button>
          </Box>
        </Paper>
      </Box>
    );
  }

  return <>{children}</>;
};

export default MaintenanceWrapper;
